import React from "react";
import PropTypes from "prop-types";

import styles from './transactions.module.css';
import { Swap, User } from "assets/svgComponents";


/**
 * 
 * @param { credit | debit | swap | user } type This specify the status of transaction
 *  
 */

const TransactionType = ({type="credit", className, ...props}) => {
    return (
        <div className={`${styles.TransactionType} ${styles[type]} ${className|| ""}`} {...props}>
          <div>
              { type === "credit" && <span>+</span>}
              { type === "debit" && <span>_</span>}
              { type === "swap" && <Swap />}
              { type === "user" && <User />}
          </div>
        </div>
    )
}

TransactionType.propTypes = {
  variant: PropTypes.oneOf(["credit", "debit", "swap"]).isRequired,
};
export default TransactionType;
